import moment from "moment";
import { CourseWareTypeList } from "../API/courseware";
import lodash from "lodash-es";
/**
 * 根据日期确定周几 (0 - 6)
 */
export function date2Week(date: string) {
    return moment(date).weekday();
}

export function weekHanzi(week: number | string) {
    const WeeksName = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
    return WeeksName[toNumber(week) - 1];
}

/**
 * 根据日期确定周几(汉字)
 */
export function date2WeekHanzi(date: string) {
    return number2WeekHanzi(date2Week(date));
}

// 把日期转成更容易理解的时间
export function readableDate(time: string) {
    const currentTime = moment(); //当前时间
    const timeHandler = (days: number) => {
        return currentTime.clone().subtract(days, "days").startOf("day");
    };
    const yesterday = timeHandler(1);
    const inWeek = timeHandler(6);
    const isToday = moment(time).isSame(currentTime, "day");
    const isYesterday = moment(time).isSame(yesterday, "day");
    const isWithinAWeek = moment(time).isAfter(inWeek);

    let dataTime: string;
    switch (true) {
        case isToday:
            dataTime = moment(time).format("HH:mm");
            break;
        case isYesterday:
            dataTime = "昨天";
            break;
        case isWithinAWeek:
            dataTime = moment(time).locale("zh-cn").format("dddd");
            break;
        default:
            dataTime = moment(time).format("YY/MM/DD");
    }
    return dataTime;
}

/**
 * 星期数字转汉字
 * @param num
 */
export function number2WeekHanzi(num: number) {
    const WeeksName = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
    return WeeksName[num - 1];
}

/**
 * 数字转汉字
 */
export function number2Hanzi(num: number) {
    return [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
        "二十一",
        "二十二",
        "二十三",
        "二十四",
        "二十五",
        "二十六",
        "二十七",
        "二十八",
        "二十九",
        "三十",
        "三十一",
        "三十二",
        "三十三",
        "三十四",
        "三十五",
        "三十六",
        "三十七",
        "三十八",
        "三十九",
        "四十"
    ][num];
}

/**
 * 获取节的描述 (第一节到第三节)
 * @param section
 * @param continunity
 */
export function sectionDescribe(section: string, continunity: string) {
    const num1 = Number(section);
    const num2 = Number(continunity);

    if (num2 === 1) return `第${number2Hanzi(num1)}节`;
    if (num2 === 2)
        return `第${number2Hanzi(num1)}、${number2Hanzi(num1 + 1)}节`;
    return `第${number2Hanzi(num1)}至${number2Hanzi(num1 + num2 - 1)}节`;
}

/**
 * 判断是否布尔真
 * @param value
 */
export function isTrue(value: BooleanValue): value is BooleanTrue {
    const TrueValueArray: any[] = [1, "1", true, "true", "True", "TRUE"];
    return TrueValueArray.includes(value);
}

/**
 * 任意类型转成数值
 * @param value
 */
export function toNumber(value: number | string | null | undefined) {
    if (!value) return 0;
    return Number(value) || 0;
}

/**
 * 活动时长文字
 * @param validityTime 分钟
 */
export function renderValidityTime(validityTime: number | undefined | null) {
    if (!validityTime) return "不限";
    if (validityTime > 60 * 24) return "超过一天";
    return `${validityTime}分钟`;
}

/**
 * 获取文件扩展名
 * @param file
 */
export function getExtName(file: string): string {
    if (file.indexOf(".") === -1) return "";
    return file.split(".").pop() || "";
}

/**
 * 获取七牛文件名
 * @param fileUrl
 */
export function getQiniuFileName(fileUrl: string) {
    return fileUrl.split("attname=").pop();
}

/**
 * 文件尺寸格式化
 * @param bytes
 * @param dp
 */
export function humanFileSize(bytes: number, dp = 0) {
    const thresh = 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + " B";
    }

    const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
    );

    return bytes.toFixed(dp) + units[u];
}

/**
 * 百分比转成数值
 * @param percent
 */
export function percent2Number(percent: string): number {
    if (!percent) return 0;
    return toNumber(percent.match(/\d+/)?.[0]); // 这里没考虑性能问题, 只考虑某些奇葩格式或者全角字符
}

/**
 * 格式化时间
 */
export function FormatTime(time: string) {
    const currentTime = moment(); //当前时间
    const timeHandler = (days: number) => {
        return currentTime.clone().subtract(days, "days").startOf("day");
    };
    const yesterday = timeHandler(1);
    const inWeek = timeHandler(6);
    const isToday = moment(time).isSame(currentTime, "day");
    const isYesterday = moment(time).isSame(yesterday, "day");
    const isWithinAWeek = moment(time).isAfter(inWeek);

    let dataTime: string;
    switch (true) {
        case isToday:
            dataTime = moment(time).format("HH:mm");
            break;
        case isYesterday:
            dataTime = "昨天" + " " + moment(time).format("HH:mm");
            break;
        case isWithinAWeek:
            dataTime =
                moment(time).locale("zh-cn").format("dddd") +
                " " +
                moment(time).format("HH:mm");
            break;
        default:
            dataTime = moment(time).format("YY/MM/DD HH:mm");
    }
    return dataTime;
}

/**
 * 根据关键词截取字符串
 */

export function getStrBySlice(str: string, key: string, count: number) {
    //拿到关键字的索引，按照关键字的索引裁切字符串为三段
    const index = str.indexOf(key);
    const firstWords = str.slice(0, index);
    const lastWords = str.slice(index + key.length);

    // 判断查询关键字是否是头尾
    const flag = !firstWords || !lastWords;

    const average = flag ? count : Math.floor((count - key.length) / 2);
    return {
        firstRest: firstWords.length > average ? "..." : "",
        firstText: firstWords.slice(-average),
        centerText: key,
        lastText: lastWords.slice(0, average),
        lastRest: lastWords.length > average ? "..." : ""
    };
}
/**
 * 用来将checkbox的boolean值转成0/1
 */
export function getCheckBoxFieldProps() {
    return {
        getValueProps: (value: BooleanValue) => ({ checked: isTrue(value) }),
        getValueFromEvent: (e: any) =>
            typeof e === "boolean" ? e : e.target.checked ? "1" : "0"
    };
}

/**
 * 用来将switch的boolean值转成0/1
 */
export function getSwitchFieldProps() {
    return {
        getValueProps: (value: BooleanValue) => ({ checked: isTrue(value) }),
        getValueFromEvent: (e: any) => {
            if (typeof e === "boolean") {
                return e ? "1" : "0";
            }
        }
    };
}

/**
 * 校验富文本内容是否为空
 * @param text
 */
export function isEditorTextEmpty(text: string) {
    if (!text) return true;
    return text.trim() === "<p></p>";
}

/**
 * 时间转成友好表示形式
 * @param inputTime
 * @param compareTo
 */
export function getFriendlyTime(inputTime: string, compareTo?: string) {
    return moment
        .duration(moment(inputTime).diff(moment(compareTo)))
        .humanize(true);
}

//检查上传格式
export function checkCourseWareStr(
    file: File,
    type?: Record<keyof typeof CourseWareTypeList, string[]>
) {
    const accept = lodash.flatten(Object.values(type || CourseWareTypeList));
    const MaxFileSize = 1024 * 1024 * 1024; // 附件大小限制500M
    const ext = getExtName(file.name);

    // 校验文件名
    if (/[\\|/:?*<>]/.test(file.name)) {
        return {
            next: false,
            msg: file.name + "文件名不能包含以下符号\\|/:?*<>以及\\0"
        };
    }

    // 校验文件名长度
    if (file.name.length > 200) {
        return {
            next: false,
            msg: file.name + "文件名不能超过200个字符"
        };
    }

    // 校验文件类型
    if (!accept.includes(ext?.toLowerCase() || "")) {
        return {
            next: false,
            msg: file.name + `该文件格式不允许上传`
        };
    }

    if (file.size > MaxFileSize) {
        return {
            next: false,
            msg: `${file.name}单个文件不能超过${humanFileSize(
                MaxFileSize
            )}, 上传失败`
        };
    }

    return {
        next: true,
        msg: ""
    };
}
